<template>
  <div>
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="form.gardenId" @change="selectHouse"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" disabled filterable>
            <el-option key :label="$t('lang.lab_chooseGarden')" :value="zero"></el-option>
            <el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.houseId" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')"
            class="select" @change="selectUnit" filterable>
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')" :value="zero"></el-option>
            <el-option v-for="(item,index) in houses" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="form.unitId" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormunit')"
            class="select" @change="selectRoom" filterable>
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormunit')" :value="zero"></el-option>
            <el-option v-for="(item,index) in units" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="form.roomId" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')"
            class="select" filterable>
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')" :value="zero"></el-option>
            <el-option v-for="(item,index) in rooms" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="form.searchName" :placeholder="$t('lang.lab_ownerName')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="form.placeName"
            :placeholder="$t('lang.lab_placeName')"
            clearable
            @keyup.enter.native="commit"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        
      </el-form>
    </div>
    <el-card>
      <el-row :gutter="10" class="fee-layout-row" type="flex">
        <!-- 左侧楼号/单元/房间树 -->
        <el-col :span="3" class="fee-tree-col">
          <div class="room-tree-panel" :style="{ maxHeight: treePanelMaxHeight }">
            <el-tree
              class="room-tree"
              :key="form.gardenId"
              :data="treeDataComputed"
              node-key="id"
              :props="treeProps"
              lazy
              :load="loadTreeNode"
              @node-click="handleTreeNodeClick"
            />
          </div>
        </el-col>
        <!-- 右侧收费列表 -->
      <el-col :span="21" class="fee-content-col">
      <div class="block" style="float:right;margin-bottom: 6px;">
        <el-date-picker :disabled="!closeAccount" v-model="closeMonth" type="monthrange" value-format="timestamp"
          range-separator="至" start-placeholder="封账开始月份" end-placeholder="封账结束月份">
        </el-date-picker>
        <el-button style="margin-left:10px" type="primary" slot="header" v-if="closeAccount" @click="closeAccountClick">
          确定封账</el-button>
        <el-button style="margin-left:10px" type="primary" slot="header" v-if="!closeAccount"
          @click="closeAccount=!closeAccount">封账设置</el-button>
        <el-button type="primary" slot="header" @click="showImportData()">{{detail.btn_importData}}</el-button>
          <el-button type="primary" slot="header" @click="showReceiveImportData()">{{"仪表应收导入"}}</el-button>
        <el-button type="primary" slot="header" @click="add('config')">{{detail.btn_createFeeConfig}}</el-button>
        <el-button v-if="isReceive==1" type="primary" slot="header" @click="add('receive')">
          {{detail.btn_createReceive}}</el-button>
		  <!-- <el-button type="primary" :disabled="multipleSelection.length < 2" @click="handleBatchPay" style="margin-bottom: 10px;">批量收费</el-button> -->
    
      </div>

      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        :expand-row-keys="expands"
        @expand-change="rowClick"
        :row-key="getRowKeys"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column width="30" type="expand" >
            <template slot-scope="scope">
              <el-table label-position="left" inline class="demo-table-expand"  @selection-change="handleSelectionChange" :data= "scope.row.ruleItemData"  max-height="300">
                <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
                </el-table-column>
                <el-table-column prop="gardenName" :label="detail.lab_gardenName"></el-table-column>
                <el-table-column prop="houseName" :label="detail.lab_houseName"></el-table-column>
                <el-table-column prop="unitName" :label="detail.lab_unitName"></el-table-column>
                <el-table-column prop="roomName" :label="detail.lab_roomName"></el-table-column>
                <el-table-column prop="ownerName" label="前业主姓名"></el-table-column>
                <el-table-column prop="mobile" label="前业主电话"></el-table-column>
                <el-table-column prop="buildArea" :label="detail.lab_buildArea"></el-table-column>
                <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="180px">
                  <template slot-scope="scope">
                  <el-button @click="selectDetail(scope.row,'homeFee')">{{detail.btn_roomDetail}}</el-button>
                  <el-button @click="selectDetail(scope.row,'carFee')">{{detail.btn_carDetail}}</el-button>
                  <!-- <el-button class="operation" @click="showRemark(scope.row)">{{$t('lang.resourRemark')}}</el-button> -->
                  <!-- <el-button  @click="deleteBatchData(scope.row.rId)">删除</el-button> -->
                  </template>
                </el-table-column>	
              </el-table>
          </template>
        </el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="gardenName" :label="detail.lab_gardenName"></el-table-column>
        <el-table-column prop="houseName" :label="detail.lab_houseName"></el-table-column>
        <el-table-column prop="unitName" :label="detail.lab_unitName"></el-table-column>
        <el-table-column prop="roomName" :label="detail.lab_roomName"></el-table-column>
        <el-table-column prop="ownerName" :label="detail.lab_ownerName"></el-table-column>
        <el-table-column prop="mobile" :label="detail.lab_mobile"></el-table-column>
        <el-table-column prop="buildArea" :label="detail.lab_buildArea"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="180px">
          <template slot-scope="scope">
            <el-button @click="selectDetail(scope.row,'homeFee')">{{detail.btn_roomDetail}}</el-button>
            <el-button @click="selectDetail(scope.row,'carFee')">{{detail.btn_carDetail}}</el-button>
            <el-button class="operation" @click="showRemark(scope.row)">{{$t('lang.resourRemark')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
        </el-col>
      </el-row>
    </el-card>

    <el-dialog :title="title" :visible.sync="isPopupPage" :close-on-click-modal="false" center top="5px !important"
      width="850px" @closed="handleDialogClosed">
      <el-form :model="diaForm" :rules="rules" ref="diaForm" :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item v-if="this.feex === 'config'" :label="$t('lang.lab_feeTypeCdName')" prop="feeTypeCd">
          <el-select v-model="diaForm.feeTypeCd"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" class="select"
            @change="getFeeConfigList">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" value></el-option>
            <el-option v-for="item in feeTypeList" :key="item.status_cd" :label="item.name" :value="item.status_cd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="detail.lab_locationTypeCd" prop="locationTypeCd">
          <el-select class="select" v-model="diaForm.locationTypeCd"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_locationTypeCd" @change="getLocationTypeCd"
            :disabled="locationTypeCdFlag">
            <el-option key="0" :label="$t('lang.lab_please_Select')+detail.lab_locationTypeCd" value></el-option>
            <!-- <el-option :label="detail.lab_garden" v-if="this.feex === 'config'" key="1" value="1000"></el-option> -->
            <el-option :label="detail.lab_house" key="2" value="4000"></el-option>
            <el-option :label="detail.lab_unit" key="3" value="2000"></el-option>
            <el-option :label="detail.lab_room" key="4" value="3000"></el-option>
            <el-option :label="detail.lab_room_owner" key="4" value="5000"></el-option>
          </el-select>
        </el-form-item>
        <!-- prop="gardensssss" -->
        <el-form-item :label="$t('lang.diaFormgarden')"
          v-if="diaForm.locationTypeCd == '1000'||diaForm.locationTypeCd == '2000' || diaForm.locationTypeCd == '3000' ||diaForm.locationTypeCd == '4000'||diaForm.locationTypeCd == '5000' "
          prop="gardenSelect">
          <el-select v-model="diaForm.gardenId" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')"
            class="select" @change="getHouse" disabled>
            <!-- <el-option 
            key="0"
            :label="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" 
            value></el-option> -->
            <el-option :key=0 :label="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" :value=0></el-option>
            <el-option v-for="item in gardenDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormhouse')"
          v-if="diaForm.locationTypeCd == '2000' || diaForm.locationTypeCd == '3000' ||diaForm.locationTypeCd == '4000'||diaForm.locationTypeCd == '5000' "
          prop="house">
          <el-select v-model="diaForm.house" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')"
            class="select" @change="getUnit">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')" :value="zero"></el-option>
            <el-option v-for="item in houseDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.diaFormunit')"
          v-if="diaForm.locationTypeCd == '2000' ||diaForm.locationTypeCd == '3000'||diaForm.locationTypeCd == '5000'" prop="unit">
          <el-select v-model="diaForm.unit" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormunit')"
            class="select" @change="getRoom">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormunit')" :value="zero"></el-option>
            <el-option v-for="item in unitDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.lab_theRoomNum')" v-if="diaForm.locationTypeCd === '5000'&& (['888800010001'].includes(diaForm.feeTypeCd)||feex === 'receive')" prop="room">
          <el-select v-model="diaForm.room" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')"
            class="select"  @change="getRoomOwnerlist">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')" :value="zero"></el-option>
            <el-option v-for="item in roomDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.lab_theRoomNum')" v-else-if="diaForm.locationTypeCd === '3000'&& ['888800010009', '888800010010'].includes(diaForm.feeTypeCd)" prop="room">
          <el-select v-model="diaForm.room" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')"
            class="select" @change="getPlaceNumberlist">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')" :value="zero"></el-option>
            <el-option v-for="item in roomDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.lab_theRoomNum')" v-else-if="diaForm.locationTypeCd === '3000'&& ['888800010015', '888800010016'].includes(diaForm.feeTypeCd)" prop="room">
          <el-select v-model="diaForm.room" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')"
            class="select" @change="getInstrumentNumberlist">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')" :value="zero"></el-option>
            <el-option v-for="item in roomDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_theRoomNum')" v-else-if="diaForm.locationTypeCd === '3000'" prop="room">
          <el-select v-model="diaForm.room" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')"
            class="select">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_theRoomNum')" :value="zero"></el-option>
            <el-option v-for="item in roomDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item v-if="diaForm.locationTypeCd === '5000'"
          label="业主" prop="roomOwnerId">
          <el-select v-model="diaForm.roomOwnerId"
            placeholder="请选择业主" class="select">
            <el-option key label="请选择业主" :value="zero"></el-option>
            <el-option v-for="item in roomOwnerDialist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="feex === 'config'" :label=detail.lab_feeConfigName prop="configId">
          <el-select v-model="diaForm.configId" :placeholder="$t('lang.lab_please_Select')+detail.lab_feeConfigName"
            class="select">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_feeConfigName" value></el-option>
            <el-option v-for="item in feeConfigList" :key="item.configId" :label="item.feeName" :value="item.configId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="feex === 'config'&& (diaForm.feeTypeCd == '888800010009'||diaForm.feeTypeCd == '888800010010')"
          :label="$t('lang.lab_parkingNumber')" prop="placeNumber">
          <el-select v-model="diaForm.placeNumber"
            :placeholder="$t('lang.lab_please_Select')+ $t('lang.lab_parkingNumber')" class="select">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_parkingNumber')" value></el-option>
            <el-option v-for="item in placeNumberlist" :key="item.id" :label="item.placeName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="feex === 'config'&& (diaForm.feeTypeCd == '888800010015'||diaForm.feeTypeCd == '888800010016')"
          :label="$t('lang.lab_instrumentNumber')" prop="instrumentNumber">
          <el-select v-model="diaForm.instrumentNumber"
            :placeholder="$t('lang.lab_please_Select')+ $t('lang.lab_instrumentNumber')" class="select">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_instrumentNumber')" value></el-option>
            <el-option v-for="item in instrumentNumberlist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="this.feex === 'receive'" :label=detail.lab_receiveConfig prop="configId">
          <el-select v-model="diaForm.configId" :placeholder="$t('lang.lab_please_Select')+detail.lab_receiveConfig"
            class="select">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_receiveConfig" value></el-option>
            <el-option v-for="item in feeReceiveConfigs" :key="item.configId" :label="item.feeName"
              :value="item.configId"></el-option>
          </el-select>
        </el-form-item>
        <!-- 计费使用面积 -->
        <el-form-item v-if="this.feex === 'receive' && diaForm.feeTypeCd == '888800010001'" :label=detail.lab_feeUseArea prop="useAreaId">
          <el-select v-model="diaForm.useAreaId" :placeholder="$t('lang.lab_please_Select')+detail.lab_feeUseArea"
            class="select">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_feeUseArea" value></el-option>
            <el-option v-for="item in feeUseAreaList" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!--  计费起始时间 -->
        <el-form-item class="nextPMTime" v-if="feex=='config'" :label="$t('lang.lab_startTime')" prop="startTime">
          <el-date-picker v-model="diaForm.startTime" type="date" value-format="timestamp"
            :placeholder="$t('lang.plh.sel') + $t('lang.lab_startTime')"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item class="nextPMTime" v-if="feex=='receive'" :label="$t('lang.lab_startTime')" prop="startTime">
          <el-date-picker
            v-model="diaForm.startTime"
            type="date"
            value-format="timestamp"
            :placeholder="$t('lang.plh.sel') + $t('lang.lab_startTime')"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item :label="detail.lab_period" v-if="feex=='receive'" class="nextPMTime">
          <div>
            <el-date-picker v-model="dataListQD" :format="$t('lang.lab_DATA')" value-format="timestamp" type="daterange"
              :range-separator="$t('lang.lab_to')" :start-placeholder="$t('lang.lab_startDate')"
              :end-placeholder="$t('lang.lab_endDate')">
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- //////////////////////////////////// -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('diaForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>




    <!-- 导出 -->
    <el-dialog title="收费项导入" :visible.sync="importDataDialog" :close-on-click-modal="false" center top="5px !important"
      width="850px" @closed="handleDialogClosedImportData">
      <el-form :model="importForm" :rules="rules" ref="importForm" :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="detail.lab_fee_object" prop="locationTypeCd">
          <el-select class="select" v-model="importForm.objType"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_locationTypeCd">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_fee_object" value></el-option>
            <el-option :label="detail.lab_room" value="3333"></el-option>
            <el-option :label="$t('lang.lab_carPlace')" value="6666"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.lab_feeTypeCdName')" prop="feeTypeCd">
          <el-select v-model="diaForm.feeTypeCd"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" class="select"
            @change="getFeeConfigList">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" value></el-option>
            <el-option v-for="item in feeTypeList" :key="item.status_cd" :label="item.name" :value="item.status_cd">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label=detail.lab_feeConfigName prop="configName">
          <el-select v-model="importForm.configName"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_feeConfigName" class="select">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_feeConfigName" value></el-option>
            <el-option v-for="item in feeConfigList" :key="item.configId" :label="item.feeName" :value="item.feeName">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.btn_selectExcel')" prop="">
          <!-- <el-input  placeholder="" type="file"></el-input> -->
          <input id="excelTemplate" ref="excelTemplate" type="file" class="custom-file-input form-control"
            name="excelTemplate" v-on:change="getExcelTemplate($event)" accept=".xls,.xlsx" />
          <label for="excelTemplate"
            class="custom-file-label">{{importForm.excelTemplate==''?'必填，请选择数据文件':importForm.excelTemplate.name}}</label>

        </el-form-item>
        <el-form-item label="下载模板" prop="">
          请先下载
          <a href="javascript:void(0);" @click="excelDownLoad('config')">
            导入模板
          </a>
          准备数据后，上传导入
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearImportData">取 消</el-button>
        <el-button type="primary" @click="importData('diaForm')" :disabled="isDisabled">{{detail.btn_fee_import}}
        </el-button>
      </div>
    </el-dialog>
    <!-- 应收导入 -->
    <el-dialog title="应收导入" :visible.sync="importReceiveDialog" :close-on-click-modal="false" center top="5px !important"
      width="850px" @closed="handleReceiveDialogClosedImportData">
      <el-form :model="importForm" :rules="rules" ref="importForm" :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="detail.lab_fee_object" prop="locationTypeCd">
          <el-select class="select" v-model="importForm.objType"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_locationTypeCd">
            <el-option label="仪表（度数）" value="1819"></el-option>
            <el-option label="仪表（已充值）" value="1818"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.lab_feeTypeCdName')" prop="feeTypeCd">
          <el-select v-model="diaForm.feeTypeCd"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" class="select"
            @change="getFeeConfigList">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" value></el-option>
            <el-option v-for="item in feeTypeCdList" :key="item.status_cd" :label="item.name" :value="item.status_cd">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label=detail.lab_feeConfigName prop="configName">
          <el-select v-model="importForm.configName"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_feeConfigName" class="select">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_feeConfigName" value></el-option>
            <el-option v-for="item in feeConfigList" :key="item.configId" :label="item.feeName" :value="item.feeName">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.btn_selectExcel')" prop="">
          <!-- <el-input  placeholder="" type="file"></el-input> -->
          <input id="excelTemplate" ref="excelTemplate" type="file" class="custom-file-input form-control"
            name="excelTemplate" v-on:change="getExcelTemplate($event)" accept=".xls,.xlsx" />
          <label for="excelTemplate"
            class="custom-file-label">{{importForm.excelTemplate==''?'必填，请选择数据文件':importForm.excelTemplate.name}}</label>

        </el-form-item>
        <el-form-item label="下载模板">
          请先下载
          <a href="javascript:void(0);" v-if="importForm.objType=='1818'" @click="excelDownLoad('1818')">
            《导入模板》
          </a>
          <a href="javascript:void(0);" v-if="importForm.objType=='1819'" @click="excelDownLoad('1819')">
            《导入模板》
          </a>
    
          准备数据后，上传导入
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearImportData">取 消</el-button>
        <el-button type="primary" @click="feeImportReceiveData('diaForm')" :disabled="isDisabled">{{detail.btn_fee_import}}
        </el-button>
      </div>
    </el-dialog>


    <!-- 设置弹窗 -->
    <el-dialog title="缴费情况描述" :visible.sync="remarkDialogVisible" width="40%" :close-on-click-modal="false">
      <div class='gradeRemarkBox'>
        <el-input class='gradeRemark' type="textarea" :rows="6" v-model="remarkFee">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkCancel">取 消</el-button>
        <el-button type="primary" @click="remarkConfim">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:
   *@Description:收取费用
   *@author:xubz
   *@Copyright:格科技
   *@date:2026年
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    name: '/manage/main.feePay',
    data() {
      var chooseGardenId = (rule, value, callback) => {
        if (this.diaForm.gardenId === '' || this.diaForm.gardenId === 0) {
          callback(
            new Error(
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.diaFormgardenId')
            )
          )
        } else {
          callback()
        }
      }
      var choosehouseId = (rule, value, callback) => {
        if (this.diaForm.house === '' || this.diaForm.house === 0) {
          callback(
            new Error(
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.diaFormhouse')
            )
          )
        } else {
          callback()
        }
      }
      var chooseunitId = (rule, value, callback) => {
        if (this.diaForm.unit === '' || this.diaForm.unit === 0) {
          callback(
            new Error(
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.diaFormunit')
            )
          )
        } else {
          callback()
        }
      }
      var chooseroomId = (rule, value, callback) => {
        if (this.diaForm.unit === '' || this.diaForm.unit === 0) {
          callback(
            new Error(
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_theRoomNum')
            )
          )
        } else {
          callback()
        }
      }
      return {
        expands: [],
        isExpand: false,
        feeUseAreaList: this.$i18n.t('lang.feeUseAreaList'),
        importForm: {
          objType: '',
          excelTemplate: ''
        },
        importDataDialog: false,
        importReceiveDialog: false,
        remarkDialogVisible: false,
        closeAccount: false,
        closeMonth: [],
        zero: 0, // 值为0的变量
        multipleSelection: [], // 多选框
        pageCount: 0, // 总页数
        title: '', // 弹框显示的标题
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        houseId: 0, // 楼号ID
        unitId: 0, // 单元号ID
        houseList: [], // 楼号列表
        unitList: [], // 单元号列表
        tableData: [], // 列表数组
        disabled: true,
        editId: '', // 编辑按钮保存的id
        isPopupPage: false, // 弹框的显示控制
        gardenDialist: [], // 弹框的小区列表
        houseDialist: [], // 弹框的楼号列表
        unitDialist: [], // 弹框的单元列表
        roomDialist: [], // 弹出的房间列表
        roomOwnerDialist:[],
        
        detail: this.$i18n.t('lang.feePay'), // 列表数据 xu
        diaForm: {
          useAreaId:'',
          gardenId: '',
          house: 0,
          unit: 0,
          room: 0,
          roomOwnerId:0,
          type: 1,
          locationTypeCd: '',
          feeTypeCd: '',
          configId: '',
          startTime: '',
          // -------------------------
          feeName: '',
          feeFlag: '',
          paymentCd: '',
          paymentCycle: '',
          billTypeName: '',

          endTime: '',
          computingFormula: '',
          squarePrice: '',
          additionalAmount: '',
          placeNumber: '',
          instrumentNumber:''

        },
        form: {
          houseId: '', // 楼号
          unitId: '', // 单元号
          roomId: '', // 房间号
          searchName: '', // 搜索的关键字
          placeName: '', // 车位名称模糊查询
        },
        types: [], // 小区下拉
        houses: [], //  存储根据小区请求回来的楼号
        units: [], //  存储根据楼号请求回来的单元
        rooms: [], //  存储根据单元请求回来的房间号
        feex: '',
        dataListQD: '', // 收费区间
        isReceive: '1', // 是否生成应收 --------------------------------待处理
        remarkFee: '',
        roomOwnerId: '',
        rules: {
          useAreaId: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.feePay.lab_feeUseArea'),
            trigger: 'blur',
          }, ],
          locationTypeCd: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.feePay.lab_locationTypeCd'),
            trigger: 'blur',
          }, ],
          house: [{
            required: true,
            validator: choosehouseId,
            trigger: 'change',
          }, ],
          unit: [{
            required: true,
            validator: chooseunitId,
            trigger: 'change',
          }, ],
          room: [{
            required: true,
            validator: chooseroomId,
            trigger: 'change',
          }, ],
          feeTypeCd: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_feeTypeCdName'),
            trigger: 'blur',
          }, ],
          configName: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.feePay.lab_feeConfigName'),
            trigger: 'blur',
          }, ],
          startTime: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_startTime'),
            trigger: 'blur',
          }, ],
          gardenSelect: [{
            required: true,
            validator: chooseGardenId,
            trigger: 'change',
          }, ],
          placeNumber: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_parkingNumber'),
            trigger: 'blur',
          }, ],
          roomOwnerId: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              "业主",
            trigger: 'blur',
          }, ],
          instrumentNumber: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_instrumentNumber'),
            trigger: 'blur',
          }, ]
        },
        postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
        isDisabled: true, // 保存的可点击
        // gardenId: 0, // 小区绑定的id
        // ---------------------
        isDefault: 0, //
        feeTypeList: [],
        feeTypeCdList: [],
        feeConfigList: [],
        feeReceiveConfigs: [],
        closeMonthId: '',
        locationTypeCdFlag: false,
        placeNumberlist: [],
        instrumentNumberlist: [],
        // 楼号/单元/房间树配置
        treeProps: {
          label: 'name',
          children: 'children',
          isLeaf: 'isLeaf',
        },
      }
    },
    created() {
      this.form.gardenId = this.$store.getters.gardenId
      this.diaForm.gardenId = this.$store.getters.gardenId
      this.getGarden()
      this.getHouse(this.form.gardenId)
      this.getTablelist()
      this.getFeeDictList()
      this.selectHouse(this.form.gardenId)
      this.feeReceiveConfigList()
      this.feeCloseMonth()
      console.log(this.form.gardenId)
    },
    computed: {
      ...mapGetters({
        isFeeManager: 'isFeeManager'
      }),
      // 树形结构根节点，用于触发懒加载
      treeDataComputed() {
        if (!this.form.gardenId) return []
        return [{ id: 'root-' + this.form.gardenId, name: '楼号', isLeaf: false }]
      },
      // 左侧树面板高度，与右侧表格区域对齐
      treePanelMaxHeight() {
        const enumConfig = require('@/config/enum')
        const tableHeight = this.tableData.length > 0 ? enumConfig.tableheight529 : enumConfig.tableheight109
        return (tableHeight + 46) + 'px'
      }
    },
    watch: {
      diaForm: {
        handler(newVal, oldVal) {
          // form数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule == this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
    normalizeSearchName(name) {
      return (name || '').replace(/\s+/g, '')
    },
    getRowKeys(row) {
      return row.ownerId
    },
    rowClick(row, event) {
    let loading = this.$loading()
    let params = {
          ownerId: row.ownerId,
          pageNo: this.pageNo,
          pageSize: this.pageSize
          
            
    }
    this.$get(`/feePayList/`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              debugger
                this.tableData.forEach((temp, index) => {
                  if (temp.ownerId === row.ownerId) {
                    var ll = res.list.filter(item => item.rId !== row.rId)
                    this.tableData[index].ruleItemData = ll
                    console.log(res.list)
                  }
              })
              // this.pageCount = res.pageCount
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
    },
    getRoomOwnerlist(){
            this.roomOwnerDialist = []
            this.diaForm.roomOwnerId = ''
            this.$get(`/roomOwnerChildByRoomId/` +this.diaForm.room).then(
              (res) => {
                if (res && res.errCode === 0) {
                  this.roomOwnerDialist = res.list
                }
              },
              (error) => {
                this.$message.error(error)
              }
            )
      },
      feeImportReceiveData() {
        this.$confirm(this.$i18n.t('lang.lab_isExport'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            if (this.importForm.objType == '' || this.importForm.objType == undefined) {
              this.$message.error('请选择费用对象')
              return
            }
            if (this.importForm.configName == '' || this.importForm.configName == undefined) {
              this.$message.error('请选择收费项目')
              return
            }
            if (this.diaForm.feeTypeCd == '888800010015' || this.diaForm.feeTypeCd == '888800010016') {

            } else {
              this.$message.error('该导入功能只支持水费和电费导入')
              return
            }
            if (!this.checkFileType(this.importForm.excelTemplate.name.split('.')[1])) {
              debugger
              this.$message.error('不是有效的Excel格式');
              return;
            }
            if (this.importForm.excelTemplate == '') {
              this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc'))
            } else {
              let formData = new FormData()
              formData.append('excelFile', this.importForm.excelTemplate)
              formData.append('gardenId', this.form.gardenId)
              formData.append('configName', this.importForm.configName)
              formData.append('objType', this.importForm.objType)
              let loading = this.$loading()
              this.$postFormData(`/feeImportReceiveData/`, formData).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
                    this.clearImportData()
                  } else {
                    this.$message.error(res.message)
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          })
      },
      handleReceiveDialogClosedImportData() {
        var file = document.getElementById('excelTemplate');
        file.value = ''
        this.diaForm.feeTypeCd = ''
        this.importForm.configName = ''
        this.importForm.excelTemplate = ''
        this.importReceiveDataDialog = false
      },
      handleDialogClosedImportData() {
        var file = document.getElementById('excelTemplate');
        file.value = ''
        this.diaForm.feeTypeCd = ''
        this.importForm.configName = ''
        this.importForm.excelTemplate = ''
        this.importDataDialog = false
      },
      checkFileType(fileType) {
        const acceptTypes = ['xlsx'];
        for (var i = 0; i < acceptTypes.length; i++) {
          if (fileType === acceptTypes[i]) {
            return true;
          }
        }
        return false;
      },
      clearImportData() {
        var file = document.getElementById('excelTemplate');
        file.value = ''
        this.diaForm.feeTypeCd = ''
        this.importForm.configName = ''
        this.importForm.excelTemplate = ''
        this.importDataDialog = false
        this.importReceiveDialog=false
      },
      excelDownLoad(type) {
        if ((this.diaForm.feeTypeCd == '888800010015' || this.diaForm.feeTypeCd == '888800010016')&&type=='1818') {
              this.importForm.objType="1818"
        }

        if ((this.diaForm.feeTypeCd == '888800010015' || this.diaForm.feeTypeCd == '888800010016')&&type=='1819') {
              this.importForm.objType="1819"
        }
        if (this.importForm.objType == '' || this.importForm.objType == undefined) {
          this.$message.error('请选择收费范围')
          return
        }
        if (this.diaForm.feeTypeCd == '' || this.diaForm.feeTypeCd == undefined) {
          this.$message.error('请选择收费类型')
          return
        }
        if (this.importForm.configName == '' || this.importForm.configName == undefined) {
          this.$message.error('请选择收费项目')
          return
        }
        if (this.diaForm.feeTypeCd == '888800010001' || this.diaForm.feeTypeCd == '888800010009'||this.diaForm.feeTypeCd == '888800010015' || this.diaForm.feeTypeCd == '888800010016') {

        } else {
          this.$message.error('该导入功能只支持物业费车位费水电费导入')
          return
        }
        if (this.diaForm.feeTypeCd == '888800010001' && this.importForm.objType != '3333') {
          this.$message.error('请正确选择收费类型')
          return
        }
        if (this.diaForm.feeTypeCd == '888800010009' && this.importForm.objType != '6666') {
          this.$message.error('请正确选择收费类型')
          return
        }
       
        var url = location.origin + '/mapi/feeExportData?gardenId=' + this.form.gardenId + '&objType=' + this.importForm
          .objType + '&configName=' + this.importForm.configName + '&feeTypeCd=' + this.diaForm.feeTypeCd
        //  var url=location.origin+'/zhongljBack_maven/mapi/feeExportData?gardenId='+this.form.gardenId+'&objType='+this.importForm.objType+'&configName='+this.importForm.configName
        window.open(url)
      },
      getExcelTemplate(e) {
        console.log("getExcelTemplate 开始调用" + e.target.files[0])
        this.importForm.excelTemplate = e.target.files[0]
      },
      showImportData(row) {
        this.importDataDialog = true
         var file = document.getElementById('excelTemplate');
        file.value = ''
        this.importForm.objType = ''
        this.diaForm.feeTypeCd = ''
        this.importForm.configName = ''
        this.importForm.excelTemplate = ''
      },
      showReceiveImportData(){
      this.importReceiveDialog= true
       var file = document.getElementById('excelTemplate');
        file.value = ''
        this.importForm.objType = ''
        this.diaForm.feeTypeCd = ''
        this.importForm.configName = ''
        this.importForm.excelTemplate = ''
      },
      importData() {
        this.$confirm(this.$i18n.t('lang.lab_isExport'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            if (this.importForm.objType == '' || this.importForm.objType == undefined) {
              this.$message.error('请选择费用对象')
              return
            }
            if (this.importForm.configName == '' || this.importForm.configName == undefined) {
              this.$message.error('请选择收费项目')
              return
            }
            if (this.diaForm.feeTypeCd == '888800010001' || this.diaForm.feeTypeCd == '888800010009'||this.diaForm.feeTypeCd == '888800010015' || this.diaForm.feeTypeCd == '888800010016') {

            } else {
              this.$message.error('该导入功能只支持物业费和车位费导入')
              return
            }
            if (!this.checkFileType(this.importForm.excelTemplate.name.split('.')[1])) {
              this.$message.error('不是有效的Excel格式');
              return;
            }
            if (this.importForm.excelTemplate == '') {
              this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc'))
            } else {
              let formData = new FormData()
              formData.append('excelFile', this.importForm.excelTemplate)
              formData.append('gardenId', this.form.gardenId)
              formData.append('configName', this.importForm.configName)
              formData.append('objType', this.importForm.objType)
              formData.append('feeTypeCd', this.diaForm.feeTypeCd)
              let loading = this.$loading()
              this.$postFormData(`/feeImportData/`, formData).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
                    this.clearImportData()
                  } else {
                    this.$message.error(res.message)
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          })
      },
      showRemark(row) {
        this.remarkFee = ''
        this.remarkDialogVisible = true
        this.roomOwnerId = row.rId
        this.remarkFee = row.remarkFee
      },
      remarkConfim() {
        if (this.remarkFee.trim() == '') {
          this.$message.error('请输入描述信息')
        } else {
          this.remarkDialogVisible = false
          let loading = this.$loading()
          let param = {
            remarkFee: this.remarkFee,
          }
          this.$patch(`/updateRoomOwnerRemark/` + this.roomOwnerId, param).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.getTablelist()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      remarkCancel() {
        this.remarkDialogVisible = false
      },
      getPlaceNumberlist() {
        this.placeNumberlist = []
        this.diaForm.placeNumber = ''
        let params = {
          roomId: this.diaForm.room,
        }
        this.$get(`/getPlaceNumberList`, params).then(
          (res) => {
            // this.feeConfigList.length = 0
            if (res && res.errCode === 0) {
              this.placeNumberlist = res.list
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      getInstrumentNumberlist() {
        this.instrumentNumberlist = []
        this.diaForm.instrumentNumber = ''
        let params = {
          roomId: this.diaForm.room,
         feeTypeCd: this.diaForm.feeTypeCd
        }
        this.$get(`/getWaterElectricityList`, params).then(
          (res) => {
            if (res && res.errCode === 0) {
              this.instrumentNumberlist = res.list
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      feeCloseMonth() {
        let loading = this.$loading()
        this.$get(`/getCloseMonthEntity`).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              if (res.feeCloseMonth.startTime != null && res.feeCloseMonth.startTime != undefined && res.feeCloseMonth
                .endTime != null && res.feeCloseMonth.endTime != undefined) {
                this.closeMonth.push(res.feeCloseMonth.startTime)
                this.closeMonth.push(res.feeCloseMonth.endTime)
              }
              this.closeMonthId = res.feeCloseMonth.id
              console.log(this.closeMonth)
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      closeAccountClick() {
        this.closeAccount = false
        let startMonth
        let endMonth
        console.log(this.closeMonth)
        if (this.closeMonth != null && this.closeMonth.length > 0) {
          startMonth = this.closeMonth[0]
          endMonth = this.closeMonth[1]
          console.log(startMonth)
        }
        let longinId = ''
        if (this.$store.getters.userData.id) {
          longinId = this.$store.getters.userData.id
        }
        let loading = this.$loading()
        let params = {
          startMonth: startMonth,
          endMonth: endMonth,
          userId: longinId,
          closeMonthId: this.closeMonthId
        }
        this.$post(`/closeMonth`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.isPopupPage = false
              this.closeMonthId = res.closeMonthId
              this.commit()
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      feeReceiveConfigList() {
        console.log(this.form.gardenId)
        let loading = this.$loading()
        let params = {
          gardenId: this.form.gardenId,
        }
        this.$get(`/feeReceiveConfigList/`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.feeReceiveConfigs = res.list
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      getTablelist() {
        console.log(this.form.gardenId)
        let loading = this.$loading()
        let params = {
          gardenId: this.form.gardenId,
          houseId: this.form.houseId,
          unitId: this.form.unitId,
          roomId: this.form.roomId,
          ownerName: this.normalizeSearchName(this.form.searchName),
          placeName: (this.form.placeName || '').trim(),
          isCreate:1,
          // gardenId: 5,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        this.$get(`/feePayList/`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
            
              res.list.map(item => {
                    item.ruleItemData = []
                })
              this.tableData = res.list
              this.pageCount = res.pageCount   
              this.expands = []
            }
            this.isExpand = true
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      getFeeDictList() {
        let params = {
          tableName: 'pay_fee_config',
          tableColumns: 'fee_type_cd_show'
        }
        this.$get(`/feeDictList`, params).then(
          (res) => {
            debugger
            if (res && res.errCode === 0) {
                this.feeTypeList = res.list
                res.list.filter(item => {
                if (item.status_cd == '888800010015' || item.status_cd == '888800010016') {
                  this.feeTypeCdList.push(item)
                }
              })
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      getFeeConfigList() {
        if (this.diaForm.feeTypeCd == '888800010009' || this.diaForm.feeTypeCd == '888800010010'||this.diaForm.feeTypeCd == '888800010015'||this.diaForm.feeTypeCd == '888800010016') {

          this.diaForm.locationTypeCd = '3000'
          // this.locationTypeCdFlag = true
          this.diaForm.house = 0
          this.diaForm.unit = 0
          this.unitDialist = []
          this.diaForm.room = 0
          this.roomDialist = []
          this.placeNumberlist = []
          this.diaForm.placeNumber = ''
          this.instrumentNumberlist = []
          this.diaForm.instrumentNumber = ''
        } else {
          this.diaForm.locationTypeCd = ''
          this.diaForm.house = 0
          this.diaForm.unit = 0
          this.unitDialist = []
          this.room = 0
          this.roomDialist = []
          this.locationTypeCdFlag = false
          this.placeNumberlist = []
          this.diaForm.placeNumber = ''
          this.instrumentNumberlist = []
          this.diaForm.instrumentNumber = ''
        }
        let params = {
          gardenId: this.diaForm.gardenId,
          feeTypeCd: this.diaForm.feeTypeCd
        }
        this.$get(`/feeConfigListByGardenId`, params).then(
          (res) => {
            this.diaForm.configId = ''
            // this.feeConfigList.length = 0
            if (res && res.errCode === 0) {
              this.feeConfigList = res.list
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      getLocationTypeCd() {
        switch (this.diaForm.locationTypeCd) {
          case '1000':
            // this.diaForm.gardenId = this.form.gardenId
            // this.diaForm.house = 0
            // this.houseDialist = []
            this.diaForm.unit = 0
            this.unitDialist = []
            this.room = 0
            this.roomDialist = []
            this.diaForm.roomOwner = 0
            this.roomOwnerDialist = []
            this.diaForm.roomOwnerId = 0
            this.roomOwnerDialist = []
            break
          case '4000':
            this.diaForm.unit = 0
            this.unitDialist = []
            this.room = 0
            this.roomDialist = []
            this.diaForm.roomOwnerId = 0
            this.roomOwnerDialist = []
            break
          case '2000':
            this.diaForm.room = 0
            this.roomDialist = []
            this.diaForm.roomOwnerId = 0
            this.roomOwnerDialist = []
            break
          case '3000':
            this.diaForm.roomOwnerId = 0
            this.roomOwnerDialist = []
            break
          case '5000':
            this.diaForm.roomOwnerId = 0
            this.roomOwnerDialist = []
            break
          default:
            break
        }
        this.feeReceiveConfigList()
      },
      getGarden() {
        let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.types = myGardens
        this.gardenDialist = myGardens
      },
      // 所属楼号下拉列表获取
      getHouse(gardenId) {
        this.diaForm.house = 0
        this.houseDialist = []
        this.diaForm.unit = 0
        this.unitDialist = []
        this.room = 0
        this.roomDialist = []
        this.type = 1
        if (this.diaForm.gardenId !== 0) {
          this.$get(
            `/gardenGrids?type=${this.type}&parentId=${gardenId}&pageNo=1&pageSize=999`
          ).then(
            (res) => {
              if (res && res.errCode === 0) {
                this.houseDialist = res.list
                if (this.diaForm.gardenId === 0) {
                  this.diaForm.house = 0
                  this.houseDialist = []
                  this.diaForm.unit = 0
                  this.unitDialist = []
                }
              }
            },
            (error) => {
              this.$message.error(error)
            }
          )
        }
      },
      // 所属单元下拉列表获取
      getUnit() {
        this.diaForm.unit = 0
        this.unitDialist = []
        this.diaForm.room = 0
        this.roomDialist = []
        this.placeNumberlist = []
        this.diaForm.placeNumber = ''
        this.instrumentNumberlist = []
        this.diaForm.instrumentNumber = ''
        this.type = 2
        this.$get(
          `/gardenGrids?type=${this.type}&parentId=${this.diaForm.house}&pageNo=1&pageSize=999`
        ).then(
          (res) => {
            if (res && res.errCode === 0) {
              this.unitDialist = res.list
              if (this.diaForm.house === 0) {
                this.diaForm.unit = 0
                this.unitDialist = []
              }
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      // 所在房屋号
      getRoom() {
        this.diaForm.room = 0
        this.roomDialist = []
        this.placeNumberlist = []
        this.diaForm.placeNumber = ''
        this.instrumentNumberlist = []
        this.diaForm.instrumentNumber = ''
        this.type = 3
        this.$get(
          `/gardenGrids?type=${this.type}&parentId=${this.diaForm.unit}&pageNo=1&pageSize=999`
        ).then(
          (res) => {
            if (res && res.errCode === 0) {
              this.roomDialist = res.list
              if (this.diaForm.unit === 0) {
                this.diaForm.room = 0
                this.roomDialist = []
              }
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      commit() {
        this.form.searchName = this.normalizeSearchName(this.form.searchName)
        this.form.placeName = (this.form.placeName || '').trim()
        this.pageNo = 1
        this.getTablelist()
      },
      // 弹框点击取消按钮
      clear(diaForm) {
        this.$refs[diaForm].resetFields()
        // this.diaForm.gardenId = ''
        this.diaForm.feeTypeCd = ''
        this.diaForm.feeName = ''
        this.diaForm.feeFlag = ''
        this.diaForm.paymentCd = ''
        this.diaForm.paymentCycle = ''
        this.diaForm.billTypeName = ''
        this.diaForm.startTime = ''
        this.diaForm.endTime = ''
        this.diaForm.computingFormula = ''
        this.diaForm.squarePrice = ''
        this.diaForm.additionalAmount = ''
      },

      // 添加
      add(x) {
        this.feex = x
        // this.diaForm.gardenId = ''
        this.diaForm.house = 0
        this.diaForm.unit = 0
        // this.houseDialist = []
        this.unitDialist = []

        this.diaForm.feeTypeCd = ''
        this.diaForm.feeName = ''
        this.diaForm.feeFlag = ''
        this.diaForm.paymentCd = ''
        this.diaForm.paymentCycle = ''
        this.diaForm.billTypeName = ''
        this.diaForm.startTime = ''
        this.diaForm.endTime = ''
        this.diaForm.computingFormula = ''
        this.diaForm.squarePrice = ''
        this.diaForm.additionalAmount = ''
        this.dataListQD = ''
        this.locationTypeCdFlag = false
        this.isDisabled = false
        this.isPopupPage = true
        this.diaForm.house = 0
        this.diaForm.unit = 0
        this.unitDialist = []
        this.diaForm.room = 0
        this.roomDialist = []
        this.diaForm.locationTypeCd = ''
        this.diaForm.configId = ''
        if (x == 'receive') {
          this.title = this.detail.btn_createReceive
        } else {
          this.title = this.detail.btn_createFeeConfig
        }
        this.$nextTick(() => {
          this.$refs.diaForm.clearValidate()
        })
      },
      // 查询明细
      selectDetail(row, feeRoomOrCar) {
        this.$set(row, 'feeRoomOrCar', feeRoomOrCar)
        this.$router.push({
          name: 'feeRoomList',
          query: {
            row: row
          }
        })
      },
      // 添加/保存按下确定
      save(diaForm) {
        this.$confirm(this.$i18n.t('lang.lab_isCreate'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            if (this.feex === 'config') {
              this.$refs[diaForm].validate((valid) => {
                let params = {
                  gardenId: this.diaForm.gardenId,
                  house: this.diaForm.house,
                  unit: this.diaForm.unit,
                  room: this.diaForm.room,
                  locationTypeCd: this.diaForm.locationTypeCd,
                  feeTypeCd: this.diaForm.feeTypeCd,
                  configId: this.diaForm.configId,
                  beginTs: this.diaForm.startTime,
                  placeNumber: this.diaForm.placeNumber,
                  waterElectricityId: this.diaForm.instrumentNumber,
                  roomOwnerChildId: this.diaForm.roomOwnerId,
                }
                if (valid) {
                  let loading = this.$loading()
                  this.$postJson(`/createFeeConfig`, params).then(
                    (res) => {
                      loading.close()
                      if (res && res.errCode === 0) {
                        this.$message.success(this.$i18n.t('lang.lab_save_success'))
                        this.isPopupPage = false
                        this.commit()
                      }
                    },
                    (error) => {
                      loading.close()
                      this.$message.error(error)
                    }
                  )
                }
              })
            } else if (this.feex === 'receive') {
              let startQD = this.dataListQD[0]
              let endQD = this.dataListQD[1]
              this.$refs[diaForm].validate((valid) => {
                let params = {
                  gardenId: this.diaForm.gardenId,
                  house: this.diaForm.house,
                  unit: this.diaForm.unit,
                  room: this.diaForm.room,
                  locationTypeCd: this.diaForm.locationTypeCd,
                  feeTypeCd: this.diaForm.feeTypeCd,
                  configId: this.diaForm.configId,
                  beginTs: this.diaForm.startTime,
                  useAreaId: this.diaForm.useAreaId,
                  roomOwnerChildId: this.diaForm.roomOwnerId,
                  receiveStartTime: startQD,
                  receiveEndTime: endQD
                }
                if (valid) {
                  let loading = this.$loading()
                  this.$postJson(`/createFeeReceive`, params).then(
                    (res) => {
                      loading.close()
                      if (res && res.errCode === 0) {
                        this.$message.success(this.$i18n.t('lang.lab_save_success'))
                        this.isPopupPage = false
                        this.commit()
                      }
                    },
                    (error) => {
                      loading.close()
                      this.$message.error(error)
                    }
                  )
                }
              })
            }

          })

      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      // 监听关闭dialog
      handleDialogClosed() {
        // this.$refs.diaForm.resetFields()
        this.diaForm.unit = 0
        this.diaForm.house = 0
        // this.diaForm.gardenId = ''
        this.diaForm.type = 1
        this.diaForm.name = ''
        this.diaForm.macName = ''
      },
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },

      // 获取小区下的楼号
      getListHouse() {
        this.houseId = 0
        this.houseList = []
        this.unitId = 0
        this.unitList = []
        this.type = 1
        let loading = this.$loading()
        this.$get(
          `/gardenGrids?type=${this.type}&parentId=${this.diaForm.gardenId}&pageNo=1&pageSize=999`
        ).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.houseList = res.list
              if (this.diaForm.gardenId === 0) {
                this.houseId = 0
                this.houseList = []
                this.houseList = []
                this.unitId = 0
                this.unitList = []
              }
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },

      // 根据小区选择获取楼号
      selectHouse(id) {
        this.type = 1
        this.form.houseId = ''
        this.form.unitId = ''
        this.form.roomId = ''
        this.houses = []
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据楼号选择获取单元
      selectUnit(id) {
        this.type = 2
        this.form.unitId = ''
        this.form.roomId = ''
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据单元选择获取房间
      selectRoom(id) {
        this.type = 3
        this.rooms = []
        this.form.roomId = ''
        this.gardenGrids(this.type, id)
      },
      // 楼号/单元/房间树懒加载
      loadTreeNode(node, resolve) {
        let type = 1
        let parentId = this.form.gardenId
        if (node.level === 0) {
          type = 1
          parentId = this.form.gardenId
        } else if (node.level === 1) {
          type = 2
          parentId = node.data.id
        } else if (node.level === 2) {
          type = 3
          parentId = node.data.id
        } else {
          resolve([])
          return
        }
        this.$get(`/gardenGrids/?type=${type}&parentId=${parentId}&pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              const list = res.list || []
              if (type === 3) {
                list.forEach(item => {
                  item.isLeaf = true
                })
              }
              resolve(list)
            } else {
              resolve([])
            }
          },
          () => {
            resolve([])
          }
        )
      },
      // 点击树节点，根据楼号/单元/房间切换右侧列表
      handleTreeNodeClick(data, node) {
        if (node.level !== 3) {
          return
        }
        const houseId = node.parent.parent.data.id
        const unitId = node.parent.data.id
        const roomId = data.id
        this.form.houseId = houseId
        this.form.unitId = unitId
        this.form.roomId = roomId
        this.form.searchName = ''
        this.form.placeName = ''
        // 加载下拉选项，使 filters 区域能正确显示选中值
        Promise.all([
          this.$get(`/gardenGrids/?type=1&parentId=${this.form.gardenId}&pageNo=1&pageSize=9999`),
          this.$get(`/gardenGrids/?type=2&parentId=${houseId}&pageNo=1&pageSize=9999`),
          this.$get(`/gardenGrids/?type=3&parentId=${unitId}&pageNo=1&pageSize=9999`)
        ]).then(([res1, res2, res3]) => {
          if (res1 && res1.errCode === 0) this.houses = res1.list || []
          if (res2 && res2.errCode === 0) this.units = res2.list || []
          if (res3 && res3.errCode === 0) this.rooms = res3.list || []
        })
        this.pageNo = 1
        this.getTablelist()
      },
      gardenGrids(type, id) {
        if (id === '') return
        this.$get(`/gardenGrids/?type=${this.type}&parentId=${id}&pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.houses = res.list
              } else if (this.type === 2) {
                this.units = res.list
              } else if (this.type === 3) {
                this.rooms = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 批量收费
      handleBatchPay() {
        if (this.multipleSelection.length > 0) {
          this.$router.push({
          name: 'feePay',
          query: {
            data: this.multipleSelection
          }
        })
        
        }
      },
      deleteBatchData(ids) {
        debugger
          this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            let loading = this.$loading()
              // const ids = this.multipleSelection.map(item => item.rId).join(',');
              this.$post(`/deleteBatchData`, {ids}).then(
              (res) => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_del_success'))
                  this.getTablelist()
                }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
           
      }
    }
  }
</script>

<style lang="scss" scope>
  .fee-layout-row {
    align-items: stretch;
  }

  .fee-tree-col {
    display: flex;
  }

  .room-tree-panel {
    flex: 1;
    width: 100%;
    background-color: #F2F3F5;
    border-radius: 4px;
    padding: 12px 8px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .room-tree {
    background-color: transparent;
  }

  .room-tree-panel .el-tree {
    background-color: transparent;
    height: 100%;
  }

  .room-tree-panel .el-tree-node__content:hover {
    background-color: rgba(255, 255, 255, 0.6);
  }

  .room-tree-panel .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ffffff;
  }
  .nextPMTime label {
    width: 150px !important;
  }

  .el-dialog .el-form .el-form-item {
    margin-right: 0;
    margin-bottom: 15px !important;
    text-align: left;
  }

  .key-data .el-popper {
    position: fixed !important;
    top: -72px !important;
    left: 705px !important;
    z-index: 2005;
  }

  .operation {
    margin-right: 0px;
  }

  .custom-file-input {
    position: relative;
    z-index: 2;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    margin: 0;
    opacity: 0;
  }

  .custom-file-label {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: calc(1em + .75rem);
    padding: .375rem .75rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: .25rem;
  }

  .custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(1em + .75rem);
    padding: .375rem .75rem;
    line-height: 1.5;
    color: #495057;
    content: "上传";
    background-color: #e9ecef;
    border-left: inherit;
    border-radius: 0 .25rem .25rem 0;
  }
</style>